import type { ReactNode } from 'react';
import { cn } from './cn';

/**
 * Centred label between two hairlines (design-spec §4.02 "FURTHER AFIELD"):
 * 12.5/600 label-2 text, uppercase, 1px line either side.
 *
 * Renders as a heading (`as="h2"`… ) when it introduces a group of results,
 * so screen-reader users can jump to it; the lines are decorative.
 */
export interface SectionDividerProps {
  label: ReactNode;
  as?: 'h2' | 'h3' | 'h4' | 'p';
  className?: string;
}

export function SectionDivider({
  label,
  as: Tag = 'h3',
  className,
}: SectionDividerProps) {
  return (
    <div className={cn('flex items-center gap-3.5', className)}>
      <span aria-hidden="true" className="h-px flex-1 bg-sl-line" />
      <Tag className="m-0 font-sans text-[12.5px] font-semibold uppercase tracking-[1.3px] text-sl-label-2">
        {label}
      </Tag>
      <span aria-hidden="true" className="h-px flex-1 bg-sl-line" />
    </div>
  );
}
